module.exports = __webpack_public_path__ + "041a77b2b39e30b16a7a7effae22c4f7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/隐私政策.pdf
// module id = pUcA
// module chunks = 1